import licensesStyle from '../../css/licenses.module.css';

// Components
import Button from 'components/Button';
import InlineTitle from 'components/InlineTitle';
import LinkerWithA from 'components/LinkerWithA';
import TooltipDialog from 'components/TooltipDialog';
import DropdownWithItem from 'components/DropdownWithItem';
import InputWithIconButton from 'components/InputWithIconButton';
import DropdownWithAdvancedSearch from 'components/DropdownWithAdvancedSearch';

import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import licenseService from "services/Auth.License.service";

import Nuclias from "const/nuclias";
import { uiActions } from "stores/slice/ui";

import { fromUrl } from "utils/downloadFile.util";
import { isNil, cloneDeep, size } from "lodash";

import useConst, { defaultMessages } from "../../useConst";
import licensesService from "../../service";

const { licenseConfig, deviceType } = Nuclias;

const defaultSearch = {
  searchKey: '',
  searchFields: {},
};

const defaultSearchInputKey = {
  key: '',
  org: { name: "", total: 0, },
  orgOptions: []
};

const LicensesToolbarBoxMSP = ({
  setMessages,
  changeModalStatus,
  handleSearch,
  quickSearchKey
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pageContext } = useSelector((store) => store);
  const { filterOptions, resetFilterOptions, changeOption, changeMultiOption } = useConst();
  const [search, setSearch] = useState(defaultSearch);
  const [searchInputKey, setSearchInputKey] = useState(defaultSearchInputKey);

  const initMspSearch = () => {
    setSearchInputKey(defaultSearchInputKey);
    setSearch(search => (defaultSearch));
    resetFilterOptions();
  };

  const getFilterList = (type) => {
    return filterOptions[type].data;
  };

  const getSelectedFilter = (type) => {
    for (const [index, item] of filterOptions[type].data.entries()) {
      if (item.isActive)
        return item;
    }
  };

  const changeMultiSearchOption = (list) => {
    const result = changeMultiOption(list);
    setSrarchText(result);
  };

  const changeSearchOption = (target, type, isQuick) => {
    if (isNil(target) || typeof target === 'string') {
      target = { title: '', value: target, isActive: true };
    } else {
      target = changeOption(target, type);
    }

    let field = cloneDeep(target);
    field.type = type;
    let obj = cloneDeep(search);
    if (isQuick) { obj = null; }
    setSrarchText([field], obj);
  };

  const setSrarchText = (fields, searchObj) => {
    if (isNil(searchObj))
      searchObj = cloneDeep(defaultSearch);

    for (const [fieldIndex, field] of fields.entries()) {
      field.searchType = filterOptions[field.type].searchType;
      field.name = filterOptions[field.type].name;
      searchObj.searchFields[field.type] = field;
    }

    const conditions = [];
    for (const [key, item] of Object.entries(searchObj.searchFields)) {
      if (item.value !== null && item.value !== '') {
        if (key !== 'key')
          conditions.push(`(${t(item.name)}: ${t(item.title)})`);
        else
          conditions.push(`(${t(item.name)}: ${t(item.value)})`);
      }
    }
    const conditionsStr = conditions.join(' AND ');
    searchObj.searchKey = conditionsStr;
    setSearch(search => (searchObj));
  };

  const searchOrg = async (value) => {
    dispatch(uiActions.showSpinner());
    let param = {
      search: searchInputKey.org,
      data: searchInputKey.orgOptions,
    };
    if (isNil(value)) {
      param.search = { name: "", total: 0 };
      param.data = [];
    } else {
      param.search = { name: value, total: 0 };
      param.data = [];
    }

    const res = await licensesService.searchOrgOption(param);
    const copy = cloneDeep(searchInputKey);
    copy.org = res.search;
    copy.orgOptions = res.data;
    setSearchInputKey(copy);
    dispatch(uiActions.hideSpinner());
  };

  const getMoreOrg = async () => {
    dispatch(uiActions.showSpinner());
    let param = {
      search: searchInputKey.org,
      data: searchInputKey.orgOptions,
    };
    const res = await licensesService.searchOrgOption(param);
    const copy = cloneDeep(searchInputKey);
    copy.orgOptions = res.data;
    setSearchInputKey(copy);
    dispatch(uiActions.hideSpinner());
  };

  const inputQuickSearch = (key) => {
    switch (key.value) {
      case 'expireIn60days':
        changeSearchOption({ value: 60 }, 'timeRemaining', true);
        break;
      case 'used':
        changeSearchOption({ value: licenseConfig.usedTypes.used }, 'licenseType', true);
        break;
      case 'unusedInactive':
        const uilist = [
          { value: licenseConfig.usedTypes.unused, type: 'licenseType' },
          { value: licenseConfig.statusTypes.inactive, type: 'status' }
        ];
        changeMultiSearchOption(uilist);
        break;
      case 'unusedActive':
        const ualist = [
          { value: licenseConfig.usedTypes.unused, type: 'licenseType' },
          { value: licenseConfig.statusTypes.active, type: 'status' }
        ];
        changeMultiSearchOption(ualist);
        break;
      case 'unusedInactiveAp':
        const uialist = [
          { value: licenseConfig.usedTypes.unused, type: 'licenseType' },
          { value: licenseConfig.statusTypes.inactive, type: 'status' },
          { value: deviceType.ap, type: 'licenseDeviceType' }
        ];
        changeMultiSearchOption(uialist);
        break;
      case 'unusedInactiveSwitch':
        const uislist = [
          { value: licenseConfig.usedTypes.unused, type: 'licenseType' },
          { value: licenseConfig.statusTypes.inactive, type: 'status' },
          { value: deviceType.switch, type: 'licenseDeviceType' }
        ];
        changeMultiSearchOption(uislist);
        break;
      case 'unusedInactiveGateway':
        const uiglist = [
          { value: licenseConfig.usedTypes.unused, type: 'licenseType' },
          { value: licenseConfig.statusTypes.inactive, type: 'status' },
          { value: deviceType.gateway, type: 'licenseDeviceType' }
        ];
        changeMultiSearchOption(uiglist);
        break;
      default: // =total
        return;
    }
  };

  const downloadMspGenerateList = async () => {
    const params = { mspId: pageContext.si.id };
    const res = await licenseService.getMspGenerateListUrl(params);
    const message = cloneDeep(defaultMessages);
    if (!isNil(res.error)) {
      message.error = res.error.code;
    } else {
      fromUrl(res?.data?.downloadUrl);
    }
    setMessages(message);
  };

  useEffect(() => {
    if (!isNil(quickSearchKey)) {
      initMspSearch();
      inputQuickSearch(quickSearchKey);
    }
  }, [quickSearchKey]);


  useEffect(() => {
    handleSearch(search);
  }, [search]);

  return (
    <InlineTitle isNonUnderline>
      <Button label={t('368dec020c')} className="btn-grey" onClick={() => { navigate('/settings/license-history'); }} />

      <DropdownWithAdvancedSearch
        value={search.searchKey}
        alignEnd={true}
        dataBsToggleOnInput={true}
        dataBsToggleOnButton={true}
        dropdownMenuStyle={{ minWidth: 371 }}
        readOnly
      >
        <li>
          <div className="form-title">{`${t('5dddd8b61e')} :`}</div>
          <DropdownWithItem
            id="status-dropdown"
            type="normal"
            selectedItem={getSelectedFilter('licenseType')}
            itemList={getFilterList('licenseType')}
            onClick={(e) => { changeSearchOption(e, 'licenseType'); }}
          />
        </li>
        <li>
          <div className="form-title">{`${t('ec53a8c4f0')} :`}</div>
          <DropdownWithItem
            id="status-dropdown"
            type="normal"
            selectedItem={getSelectedFilter('status')}
            itemList={getFilterList('status')}
            onClick={(e) => { changeSearchOption(e, 'status'); }}
          />
        </li>
        <li>
          <div className="form-title">{`${t('768d0c0b0b')} :`}</div>
          <DropdownWithItem
            id="status-dropdown"
            type="normal"
            selectedItem={getSelectedFilter('licenseDeviceType')}
            itemList={getFilterList('licenseDeviceType')}
            onClick={(e) => { changeSearchOption(e, 'licenseDeviceType'); }}
          />
        </li>
        <li>
          <div className="form-title">{`${t('5d5c4ad5db')} :`}</div>
          <InputWithIconButton
            value={searchInputKey?.key}
            type="search"
            placeholder={t('13348442cc')}
            autoComplete="msp-search"
            buttonClassName="icon-search-enter"
            onChange={e => {
              setSearchInputKey(searchInputKey => ({ ...searchInputKey, key: e.target.value }));
            }}
            onClick={e => {
              if (size(searchInputKey?.key) > 0) {
                setSearchInputKey(searchInputKey => ({ ...searchInputKey, key: '' }));
                changeSearchOption('', 'licenseKey');
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                changeSearchOption(e.target.value, 'licenseKey');
              }
            }}
          />
        </li>
        <li>
          <div className="form-title">{`${t('c1ca926603')} :`}</div>
          <div className={licensesStyle['advanced-select-org-container']}>
            <DropdownWithAdvancedSearch
              value={searchInputKey?.org?.name}
              buttonIcon={'enter'}
              dataBsToggleOnInput={true}
              onChange={e => {
                const copy = cloneDeep(searchInputKey);
                copy.org.name = e.target.value;
                setSearchInputKey(copy);
              }}
              onClick={e => {
                searchOrg(null);
                changeSearchOption(null, 'searchOrgId');
                const copy = cloneDeep(searchInputKey);
                copy.org.name = '';
                setSearchInputKey(copy);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  searchOrg(e.target.value);
                }
              }}
              buttonOnClick={(e) => {
                searchOrg(searchInputKey.org.name);
                e.stopPropagation();
              }}
            //
            >
              <div className={licensesStyle['more-org']}>
                <div className={licensesStyle['show-more-info']}>
                  {`${t("3a6d32cc65", { "count": searchInputKey?.orgOptions?.length })} ${searchInputKey?.org?.total
                    } ${t("cfb453439b")}.`}
                </div>
                <LinkerWithA
                  label={t('2a725a2a3d')}
                  href="#"
                  className="linker-blue show-more text-decoration-underline"
                  onClick={(e) => {
                    getMoreOrg();
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                ></LinkerWithA>
              </div>
              {searchInputKey?.orgOptions?.map((item, index) => {
                return (
                  <li
                    key={index}
                    className="search-org-item"
                    onClick={() => {
                      changeSearchOption(item, 'searchOrgId');
                      const copy = cloneDeep(searchInputKey);
                      copy.org.name = item.name;
                      setSearchInputKey(copy);
                    }}
                  >
                    {item.name}
                  </li>
                );
              })}
            </DropdownWithAdvancedSearch>
          </div>
        </li>
        <li>
          <div className="form-title">{`${t('4d29676394')} :`}</div>
          <DropdownWithItem
            id="status-dropdown"
            type="normal"
            selectedItem={getSelectedFilter('timeRemaining')}
            itemList={getFilterList('timeRemaining')}
            onClick={(e) => { changeSearchOption(e, 'timeRemaining'); }}
          />
        </li>
      </DropdownWithAdvancedSearch>

      <Button
        label={t('de3e350386')}
        className="btn-grey"
        onClick={() => changeModalStatus('generate', true)}
      />

      <Button
        label={t('801ab24683')}
        className="btn-grey"
        onClick={() => {
          downloadMspGenerateList();
        }}
      />

      <TooltipDialog
        placement="left"
        title={t('9d53acb410')}
      ></TooltipDialog>
    </InlineTitle>
  );
};

export default LicensesToolbarBoxMSP;